import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApiCacheService } from '@shared/services/cache-service/api-cache.service';
import { SignalsService } from '@shared/services/signals/signals.service';
import { AppService } from 'app/app.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading-modal',
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule
  ],
  templateUrl: './loading-modal.component.html',
  styleUrl: './loading-modal.component.scss'
})
export class LoadingModalComponent {


  constructor(
    private cacheService: ApiCacheService,
    private signalService: SignalsService,
    public appService: AppService
  ) { }

  cancelRequest() {
    this.cacheService.ngOnDestroy();
    this.signalService.isLoading$.set(false);
  }
}
